import { jsxs, jsx } from 'react/jsx-runtime';

// src/AriaSettingsForm.tsx
var AI_MODE_OPTIONS = [
  { value: "local", label: "Lokal", hint: "Antworten vom lokalen Modell \u2014 Daten bleiben in der IT-SCE-Infrastruktur." },
  { value: "cloud", label: "Cloud", hint: "Leistungsfaehigere Cloud-Modelle (EU-Region je nach Datenschutz-Einstellung)." }
];
var PRIVACY_MODE_OPTIONS = [
  { value: "eu_only", label: "Nur EU", hint: "Verarbeitung ausschliesslich in der EU." },
  { value: "us_ok", label: "EU + US", hint: "US-Transfer erlaubt (mehr Modellauswahl)." }
];
function cls(...parts) {
  return parts.filter(Boolean).join(" ");
}
function Segmented(props) {
  const { legend, description, options, value, inheritLabel, disabled, onSelect } = props;
  const all = inheritLabel ? [{ value: null, label: inheritLabel }, ...options] : options;
  return /* @__PURE__ */ jsxs("fieldset", { className: "space-y-2", disabled, children: [
    /* @__PURE__ */ jsx("legend", { className: "text-sm font-medium text-gray-900 dark:text-gray-100", children: legend }),
    description && /* @__PURE__ */ jsx("p", { className: "text-xs text-gray-500 dark:text-gray-400", children: description }),
    /* @__PURE__ */ jsx("div", { className: "inline-flex flex-wrap gap-1 rounded-lg bg-gray-100 dark:bg-gray-800 p-1", children: all.map((opt) => {
      const active = value === opt.value;
      return /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          "aria-pressed": active,
          disabled,
          title: opt.hint,
          onClick: () => onSelect(opt.value),
          className: cls(
            "px-3 py-1.5 text-sm rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
            active ? "bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm font-medium" : "text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
          ),
          children: opt.label
        },
        String(opt.value)
      );
    }) }),
    value != null && options.find((o) => o.value === value)?.hint && /* @__PURE__ */ jsx("p", { className: "text-xs text-gray-500 dark:text-gray-400", children: options.find((o) => o.value === value)?.hint })
  ] });
}
function AriaSettingsForm({
  values,
  onChange,
  fields,
  allowInheritAiMode = true,
  className
}) {
  const aiFlags = fields?.ai_mode;
  const privacyFlags = fields?.privacy_mode;
  return /* @__PURE__ */ jsxs("div", { className: cls("space-y-6", className), children: [
    !privacyFlags?.hidden && /* @__PURE__ */ jsx(
      Segmented,
      {
        legend: "Datenschutz",
        description: "Wo duerfen Anfragen verarbeitet werden?",
        options: PRIVACY_MODE_OPTIONS,
        value: values.privacy_mode,
        disabled: privacyFlags?.disabled,
        onSelect: (v) => v != null && onChange({ ...values, privacy_mode: v })
      }
    ),
    !aiFlags?.hidden && /* @__PURE__ */ jsx(
      Segmented,
      {
        legend: "KI-Modus",
        description: "Lokales Modell oder leistungsfaehigere Cloud-Modelle.",
        options: AI_MODE_OPTIONS,
        value: values.ai_mode,
        inheritLabel: allowInheritAiMode ? "Org-Standard" : void 0,
        disabled: aiFlags?.disabled,
        onSelect: (v) => onChange({ ...values, ai_mode: v })
      }
    )
  ] });
}

export { AriaSettingsForm };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map